import { useLayoutEffect, useState } from "react"
import { NAVIGATIONAL_MENU_OFFSET } from "../../constants"

// Set value to be between the range [0, value]
const clamp = value => Math.max(0, value)

// Check if number is between particular values
const isBetween = (value, floor, ceil) => value >= floor && value <= ceil

const extractIDNumbers = (fullID) => fullID.match(/\d+$/)?.[0];

const useArticleNavigation = (topics) => {
  const [activeId, setActiveId] = useState("")
  const collectedTopics = document.querySelectorAll('[id^="article-topic-"]')

  useLayoutEffect(() => {
    const observer = () => {
      const scroll = window.scrollY

      const position = [...collectedTopics]?.map(({ id }) => ({ id }))?.map(({ id }) => {
          const element = document.getElementById(id)

          if (!element) return { id, top: -1, bottom: -1 }

          const rect = element.getBoundingClientRect()
          const top = clamp(rect.top + scroll - NAVIGATIONAL_MENU_OFFSET)
          const bottom = clamp(rect.bottom + scroll - NAVIGATIONAL_MENU_OFFSET)

          return { id, top, bottom }
        }).find(({ top, bottom }) => isBetween(scroll, top, bottom))

      if (position) {
        const { id } = position
        setActiveId(id)
      }
    }

    window.addEventListener("resize", observer)
    window.addEventListener("scroll", observer)

    return () => {
      window.removeEventListener("resize", observer)
      window.removeEventListener("scroll", observer)
    }
  }, [topics])

  return Number(extractIDNumbers(activeId));
}

export default useArticleNavigation
